import WithErrorPageLayout from './WithErrorPageLayout'

export default WithErrorPageLayout
